"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.type === _serverConstants.SERVER_DISCONNECT) {
    return _extends({}, state, {
      connected: false
    });
  }

  if (action.type === _serverConstants.SERVER_ERROR) {
    return _extends({}, state, {
      notifications: [].concat(_toConsumableArray(state.notifications), [action.notification])
    });
  }

  if (action.type === _serverConstants.SERVER_UPDATE) {
    return _extends({}, state, {
      notifications: [].concat(_toConsumableArray(state.notifications), [action])
    });
  }

  if (action.type === _serverConstants.SERVER_ACKNOWLEDGE_NOTIFICATION) {
    var notificationsCopy = [].concat(_toConsumableArray(state.notifications));
    var index = void 0;
    state.notifications.find(function (note, idx) {
      if (note.uid === action.uid) {
        index = idx;
        return true;
      }
    });

    notificationsCopy[index] = _extends({}, notificationsCopy[index], {
      visible: false
    });
    return _extends({}, state, {
      notifications: notificationsCopy
    });
  }

  return state;
};

var _serverConstants = require("./serverConstants");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  connected: true,
  notifications: []
};
//# sourceMappingURL=serverReducer.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/server/serverReducer.js
// module id = 255
// module chunks = 0